<template>
  <div
    class="px-2 py-3"
    :class="compact ? 'flex items-center gap-3' : 'flex justify-between'"
  >
    <span class="text-sm" :class="{ 'text-primary font-medium': compact }">
      {{ barrier.name }}
    </span>
    <BaseInputToggle
      :model-value="barrierOn"
      @update:model-value="handleUpdateModelValue"
    >
      <template #label>
        <HeadlessSwitchLabel
          as="span"
          class="text-primary order-first mr-3 text-sm font-medium"
        >
          OPEN
        </HeadlessSwitchLabel>
      </template>
    </BaseInputToggle>
  </div>
</template>

<script setup lang="ts">
import { type Barrier } from "@/services/barriers/listBarriers";
const props = defineProps<{ barrier: Barrier; compact?: boolean }>();

const barrierOn = refAutoReset(false, 5 * 1000);

const handleUpdateModelValue = async (value: boolean) => {
  if (!value) {
    barrierOn.value = false;
    return;
  }

  barrierOn.value = true;
  try {
    await pulseBarrier(props.barrier.id);
  } catch {
    barrierOn.value = false;
  }
};
</script>
